export const OPTIMIZELY_SCRIPT_ID = 'optimizely-init-script';
export const OPTIMIZELY_SCRIPT_SRC = 'https://cdn.optimizely.com/js/6089398316433408.js';
